import gql from 'graphql-tag';
import { dwellerCreateResponseFragment } from '../fragments';

export const createDweller = gql`
  mutation createDweller($dweller: DwellerInput!) {
    dwellerCreate(dweller: $dweller) {
      ...dwellerCreateResponseParts
    }
  }

  ${dwellerCreateResponseFragment}
`;

export const updateDweller = gql`
  mutation updateDweller($dweller: DwellerUpdateInput!) {
    dwellerUpdate(dweller: $dweller)
  }
`;
